"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as m } from "react";
import a from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ e(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.906 7.318A2.07 2.07 0 0 1 7.974 5.25a2.07 2.07 0 0 1 2.068 2.068 2.07 2.07 0 0 1-2.068 2.068 2.07 2.07 0 0 1-2.068-2.068m-1.25 0a3.32 3.32 0 0 0 3.318 3.318 3.32 3.32 0 0 0 3.318-3.318A3.32 3.32 0 0 0 7.974 4a3.32 3.32 0 0 0-3.318 3.318M2 16.801a.625.625 0 0 0 1.25 0v-1.91c0-.938.763-1.7 1.701-1.7h5.045a.626.626 0 0 0 0-1.25H4.951A2.955 2.955 0 0 0 2 14.89zm13.67-9.07a2.25 2.25 0 0 0-2.247 2.246 2.25 2.25 0 0 0 2.247 2.248 2.25 2.25 0 0 0 2.248-2.248 2.25 2.25 0 0 0-2.248-2.246m0 5.744a3.5 3.5 0 0 1-3.497-3.498 3.5 3.5 0 0 1 3.497-3.496 3.5 3.5 0 0 1 3.498 3.496 3.5 3.5 0 0 1-3.498 3.498m5.08 6.095a.625.625 0 0 0 1.25 0v-2.036a3.11 3.11 0 0 0-3.106-3.107h-6.448a3.11 3.11 0 0 0-3.105 3.107v2.036a.625.625 0 0 0 1.25 0v-2.036c0-1.024.832-1.857 1.855-1.857h6.448c1.023 0 1.856.833 1.856 1.857z",
        clipRule: "evenodd"
      }
    )
  }
), h = m(r);
export {
  h as MembershipHub,
  h as default
};
